export type { RequestDetailsUIState } from './reducer';
export { requestDetailsReducer, ApprovalDecision } from './reducer';
